import { collection, addDoc, getDocs, query, where, orderBy, limit, Timestamp } from 'firebase/firestore';
import { db } from '@/config/firebase';
import { CopyAnalysisResult } from '@/types/copyAnalysis';

export interface AnalysisRecord extends CopyAnalysisResult {
  id?: string;
  userId: string;
  url: string;
  createdAt: Timestamp;
}

const ANALYSIS_COLLECTION = 'analyses';

export async function saveAnalysis(userId: string, url: string, analysis: CopyAnalysisResult) {
  try {
    const analysisData: Omit<AnalysisRecord, 'id'> = {
      userId,
      url,
      ...analysis,
      createdAt: Timestamp.now()
    };

    const docRef = await addDoc(collection(db, ANALYSIS_COLLECTION), analysisData);
    return docRef.id;
  } catch (error) {
    console.error('Error saving analysis:', error);
    throw new Error('Failed to save analysis');
  }
}

export async function getUserAnalyses(userId: string) {
  try {
    const analysesRef = collection(db, ANALYSIS_COLLECTION);
    const q = query(
      analysesRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc'),
      limit(10)
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as AnalysisRecord[];
  } catch (error) {
    console.error('Error fetching user analyses:', error);
    throw error;
  }
}